import { ref } from "vue";

export function useFlyAnimation() {
	const productCardRefs = ref<Record<string, HTMLElement>>({});
	const groupCardRefs = ref<Record<string, HTMLElement>>({});
	const flyerClone = ref<HTMLElement | null>(null);

	const scrollProductIntoView = (container: HTMLElement | null, card: HTMLElement | null) => {
		if (!container || !card) return;

		const containerRect = container.getBoundingClientRect();
		const cardRect = card.getBoundingClientRect();

		const cardOffsetLeft = cardRect.left - containerRect.left + container.scrollLeft;
		const centeredLeft = cardOffsetLeft - (container.clientWidth - card.offsetWidth) / 2;

		container.scrollTo({
			left: Math.max(0, centeredLeft),
			behavior: "smooth",
		});
	};

	const triggerFlyAnimation = (productCard: HTMLElement | undefined, groupCard: HTMLElement | undefined) => {
		if (!(productCard instanceof HTMLElement) || !(groupCard instanceof HTMLElement)) return;

		const innerCard = productCard.querySelector(".card__main__wrapper") as HTMLElement;
		if (!innerCard) return;

		const start = innerCard.getBoundingClientRect();
		const end = groupCard.getBoundingClientRect();
		const clone = innerCard.cloneNode(true) as HTMLElement;
		clone.classList.add("combo-flyer");
		Object.assign(clone.style, {
			width: `${start.width}px`,
			height: `${start.height}px`,
			left: `${start.left}px`,
			top: `${start.top}px`,
			position: "fixed",
			zIndex: "1000",
			pointerEvents: "none",
		});
		document.body.appendChild(clone);
		flyerClone.value = clone;

		requestAnimationFrame(() => {
			const dx = end.left + end.width / 2 - (start.left + start.width / 2);
			const dy = end.top + end.height / 2 - (start.top + start.height / 2);
			const scale = (end.width / start.width) * 0.3;

			clone.style.transform = `translate(${dx}px, ${dy}px) scale(${scale})`;
			clone.style.opacity = "0.3";
			clone.style.transition = "transform 0.5s ease, opacity 0.5s ease";
		});

		clone.addEventListener(
			"transitionend",
			() => {
				clone.remove();
				flyerClone.value = null;
				groupCard.classList.add("bump");
				setTimeout(() => groupCard.classList.remove("bump"), 300);
			},
			{ once: true },
		);
	};

	return {
		productCardRefs,
		groupCardRefs,
		flyerClone,
		scrollProductIntoView,
		triggerFlyAnimation,
	};
}